(() => {
  const filterSelectors = [
    '#blog-tag-filter',
    '#blog-ingredient-filter',
    '#blog-feeling-filter'
  ].join(', ');

  function filterUrl() {
    const product = document.querySelector('#blog-tag-filter')?.value || '';
    const ingredient = document.querySelector('#blog-ingredient-filter')?.value || '';
    const mood = document.querySelector('#blog-feeling-filter')?.value || '';
    const tags = [product, ingredient, mood].filter(Boolean).join('+');
    const params = new URLSearchParams();

    if (ingredient) params.set('ingredient', ingredient);
    if (mood) params.set('feeling', mood);

    return `${tags ? `/blogs/recipes/tagged/${tags}` : '/blogs/recipes'}${params.size ? `?${params}` : ''}#top`;
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches(filterSelectors)) return;
    window.location.assign(filterUrl());
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('#reset-all-button')) return;
    event.preventDefault();
    window.location.assign('/blogs/recipes#top');
  });
})();
